import { styled, Theme, Typography } from "@material-ui/core";
import React from "react";

export const PRODUCT_DETAILS_ACTIONS_MAX_WIDTH = "350px";
export const PRODUCT_DETAILS_ACTIONS_HEIGHT = "40px";

export const StoreTextButton = styled("button")(({ theme }) => ({
  fontFamily: "Roobert, Arial",
  textDecoration: "underline",
  border: "none",
  outline: "none",
  padding: 0,
  background: "transparent",
  "&:hover": {
    color: theme.palette.primary.dark
  }
}));

export const AvailabilityTypography = styled(Typography)(
  ({ theme }: { theme: Theme; component?: React.ElementType }) => ({
    fontSize: "1.4rem",
    lineHeight: "2rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.4rem",
      lineHeight: "1.8rem",
      textAlign: "center"
    },
    "& .orange": {
      color: theme.palette.expressDelivery,
      whiteSpace: "nowrap"
    },
    "& button": {
      fontSize: "1.4rem",
      lineHeight: "2rem",
      [theme.breakpoints.down("xs")]: {
        fontSize: "1.4rem",
        lineHeight: "1.8rem"
      }
    }
  })
);

export const AddressTextButton = styled("button")(({ theme }) => ({
  fontFamily: "Roobert, Arial",
  fontWeight: 600,
  border: "none",
  outline: "none",
  padding: 0,
  background: "transparent",
  "& svg": {
    transform: "translate(1px, 3px)"
  },
  "&:hover": {
    color: theme.palette.primary.dark,
    "& svg path": {
      fill: theme.palette.primary.dark
    }
  }
}));
